<div class="row">
  <div class="col-md-12 mb-2 mt-1">
    <label class="label1">School Name :
      <label class="label2 ms-2">{{milestoneData?.locationname}}</label>
    </label>
  </div>
  <div class="row milestone">
    <div class="col-md-4 ps-0">
      <button mat-raised-button class="btn link addnew" color='primary'
        (click)="labPrerequisites(milestoneData?.fk_labtypeId)">Lab Prerequisites </button>
    </div>
    <div class="col-md-4 text-center">
      <h4 class="heading2">Milestone</h4>
    </div>
    <div class="col-md-4 text-end pe-0">
      <button mat-raised-button class="btn link addnew" color='primary'
        (click)="listOfItems(milestoneData?.fk_labtypeId)">List of Items </button>
    </div>
  </div>
  <div class="col-md-12 mt-3">
    <div class="row">
      <div class="col-md-6">
        <label class="label1">Lab Type :
          <label class="label2 ms-2">{{milestoneData?.labtype}}</label>
        </label>
      </div>
      <div class="col-md-6 text-end">
        <label class="label1">Dispatch No. :
          <label class="label2 ms-2">{{milestoneData?.dispatchno}}</label>
        </label>
      </div>
    </div>
    <div class="stepper-container">
      <div class="step"
        [ngClass]="milestoneData?._lstMilestoneData[0]?.milestonedate ? 'active': milestoneData?._lstMilestoneData[0]?.inprocessstatus ? 'in-process': ''">
        <div class="row">
          <div class="d-flex flex-column align-items-center justify-content-center">
            <div class="circle">
              <span class="material-icons">
                local_shipping
              </span>
            </div>
            <div class="text-center pt-2">
              <div class="status">{{milestoneData?._lstMilestoneData[0]?.milestonename}}</div>
              <div class="date text-muted">{{milestoneData?._lstMilestoneData[0]?.milestonedate}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="line"
        [ngClass]="milestoneData?._lstMilestoneData[1]?.milestonedate ? 'active': milestoneData?._lstMilestoneData[1]?.inprocessstatus ? 'in-process': ''">
      </div>

      <div class="step"
        [ngClass]="milestoneData?._lstMilestoneData[1]?.milestonedate ? 'active': milestoneData?._lstMilestoneData[1]?.inprocessstatus ? 'in-process': ''">
        <div class="row">
          <div class="d-flex flex-column align-items-center justify-content-center">
            <div class="circle">
              <span class="material-icons">
                rv_hookup
              </span>
            </div>
            <div class="text-center pt-2">
              <div class="status">{{milestoneData?._lstMilestoneData[1]?.milestonename}}</div>
              <div class="date text-muted">{{milestoneData?._lstMilestoneData[1]?.milestonedate}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="line"
        [ngClass]="milestoneData?._lstMilestoneData[2]?.milestonedate ? 'active': milestoneData?._lstMilestoneData[2]?.inprocessstatus ? 'in-process': ''">
      </div>
      <div class="step"
        [ngClass]="milestoneData?._lstMilestoneData[2]?.milestonedate ? 'active': milestoneData?._lstMilestoneData[2]?.inprocessstatus ? 'in-process': ''">
        <div class="row">
          <div class="d-flex flex-column align-items-center justify-content-center">
            <div class="circle">
              <span class="material-icons">
                file_download_done
              </span>
            </div>
            <div class="text-center pt-2">
              <div class="status">{{milestoneData?._lstMilestoneData[2]?.milestonename}}</div>
              <div class="date text-muted">{{milestoneData?._lstMilestoneData[2]?.milestonedate}}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="line"
        [ngClass]="milestoneData?._lstMilestoneData[3]?.milestonedate ? 'active': milestoneData?._lstMilestoneData[3]?.inprocessstatus ? 'in-process': ''">
      </div> -->

      <!-- <div class="step"
        [ngClass]="milestoneData?._lstMilestoneData[3]?.milestonedate ? 'active': milestoneData?._lstMilestoneData[3]?.inprocessstatus ? 'in-process': ''">
        <div class="row">
          <div class="d-flex flex-column align-items-center justify-content-center">
            <div class="circle">
              <span class="material-icons">
                recommend
              </span>
            </div>
            <div class="text-center pt-2">
              <div class="status">{{milestoneData?._lstMilestoneData[3]?.milestonename}}</div>
              <div class="date text-muted">{{milestoneData?._lstMilestoneData[3]?.milestonedate}}</div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</div>

<div class="row mb-2">
  <div class="col-md-12 text-center">
    <button mat-raised-button class="reset" color="basic" type="button" (click)="viewDocDetails()">
      View Details
    </button>
  </div>
</div>
<div class="row">
  <div class="col-md-12 p-0">
    <mat-expansion-panel [expanded]="isExpanded" class="padding-0">
      <div class="row align-items-center tabledesign">
        <p-table [scrollable]="true" [value]="docDetalis?.listData" styleClass="p-datatable-striped">

          <ng-template pTemplate="colgroup">
            <colgroup>
              <col style="width:65px">
              <col style="width:100px">
              <col style="width:120px">
              <col style="width:120px">
              <col style="width:300px">
              <col style="width:70px">
            </colgroup>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th class="text-center">S.No.</th>
              <th>Milestone</th>
              <th>Dated</th>
              <th>
                Status
              </th>
              <th>Reason</th>
              <th class="text-center">Files </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-i="rowIndex">
            <tr>
              <td class="text-center"> {{i+1}}</td>
              <td>
                {{data?.milestonename}}
              </td>
              <td>
                {{data?.dated}}
              </td>
              <td>
                <div class="d-flex flex-column"> <label class="label">{{data?.status1}} </label>

                </div>
              </td>
              <td>{{data?.description}}</td>
              <td class="text-center">

                <i class="pi pi-images pointer me-2" pTooltip="View Files" tooltipPosition="bottom"
                  (click)="openImages(data)"></i>


              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" class="text-center">
                No record found
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </mat-expansion-panel>
  </div>
</div>


<div class="row" *ngIf="milestoneData?.dispatchno1">
  <!-- <div class="col-md-12 mb-2 mt-1">
    <label class="label1">School Name :
      <label class="label2 ms-2">{{milestoneData?.locationname}}</label>
    </label>
  </div> -->
  <div class="row milestone">
    <div class="col-md-4 ps-0">
      <button mat-raised-button class="btn link addnew" color='primary'
        (click)="labPrerequisites(milestoneData?.fk_labtypeId1)">Lab Prerequisites </button>
    </div>
    <div class="col-md-4 text-center">
      <h4 class="heading2">Milestone</h4>
    </div>
    <div class="col-md-4 text-end pe-0">
      <button mat-raised-button class="btn link addnew" color='primary'
        (click)="listOfItems(milestoneData?.fk_labtypeId1)">List of Items </button>
    </div>
  </div>
  <div class="col-md-12 mt-3">
    <div class="row">
      <div class="col-md-6">
        <label class="label1">Lab Type :
          <label class="label2 ms-2">{{milestoneData?.labtype1}}</label>
        </label>
      </div>
      <div class="col-md-6 text-end">
        <label class="label1">Dispatch No. :
          <label class="label2 ms-2">{{milestoneData?.dispatchno1}}</label>
        </label>
      </div>
    </div>
    <div class="stepper-container">
      <div class="step"
        [ngClass]="milestoneData?._lstMilestoneData1[0]?.milestonedate ? 'active': milestoneData?._lstMilestoneData1[0]?.inprocessstatus ? 'in-process': ''">
        <div class="row">
          <div class="d-flex flex-column align-items-center justify-content-center">
            <div class="circle">
              <span class="material-icons">
                local_shipping
              </span>
            </div>
            <div class="text-center pt-2">
              <div class="status">{{milestoneData?._lstMilestoneData1[0]?.milestonename}}</div>
              <div class="date text-muted">{{milestoneData?._lstMilestoneData1[0]?.milestonedate}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="line"
        [ngClass]="milestoneData?._lstMilestoneData1[1]?.milestonedate ? 'active': milestoneData?._lstMilestoneData1[1]?.inprocessstatus ? 'in-process': ''">
      </div>

      <div class="step"
        [ngClass]="milestoneData?._lstMilestoneData1[1]?.milestonedate ? 'active': milestoneData?._lstMilestoneData1[1]?.inprocessstatus ? 'in-process': ''">
        <div class="row">
          <div class="d-flex flex-column align-items-center justify-content-center">
            <div class="circle">
              <span class="material-icons">
                rv_hookup
              </span>
            </div>
            <div class="text-center pt-2">
              <div class="status">{{milestoneData?._lstMilestoneData1[1]?.milestonename}}</div>
              <div class="date text-muted">{{milestoneData?._lstMilestoneData1[1]?.milestonedate}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="line"
        [ngClass]="milestoneData?._lstMilestoneData1[2]?.milestonedate ? 'active': milestoneData?._lstMilestoneData1[2]?.inprocessstatus ? 'in-process': ''">
      </div>
      <div class="step"
        [ngClass]="milestoneData?._lstMilestoneData1[2]?.milestonedate ? 'active': milestoneData?._lstMilestoneData1[2]?.inprocessstatus ? 'in-process': ''">
        <div class="row">
          <div class="d-flex flex-column align-items-center justify-content-center">
            <div class="circle">
              <span class="material-icons">
                file_download_done
              </span>
            </div>
            <div class="text-center pt-2">
              <div class="status">{{milestoneData?._lstMilestoneData1[2]?.milestonename}}</div>
              <div class="date text-muted">{{milestoneData?._lstMilestoneData1[2]?.milestonedate}}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="line"
        [ngClass]="milestoneData?._lstMilestoneData1[3]?.milestonedate ? 'active': milestoneData?._lstMilestoneData1[3]?.inprocessstatus ? 'in-process': ''">
      </div> -->

      <!-- <div class="step"
        [ngClass]="milestoneData?._lstMilestoneData1[3]?.milestonedate ? 'active': milestoneData?._lstMilestoneData1[3]?.inprocessstatus ? 'in-process': ''">
        <div class="row">
          <div class="d-flex flex-column align-items-center justify-content-center">
            <div class="circle">
              <span class="material-icons">
                recommend
              </span>
            </div>
            <div class="text-center pt-2">
              <div class="status">{{milestoneData?._lstMilestoneData1[3]?.milestonename}}</div>
              <div class="date text-muted">{{milestoneData?._lstMilestoneData1[3]?.milestonedate}}</div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</div>

<div class="row mb-2" *ngIf="milestoneData?.dispatchno1">
  <div class="col-md-12 text-center">
    <button mat-raised-button class="reset" color="basic" type="button" (click)="viewDocDetails1()">
      View Details
    </button>
  </div>
</div>
<div class="row" *ngIf="milestoneData?.dispatchno1">
  <div class="col-md-12 p-0">
    <mat-expansion-panel [expanded]="isExpanded1" class="padding-0">
      <div class="row align-items-center tabledesign">
        <p-table [scrollable]="true" [value]="docDetalis1?.listData" styleClass="p-datatable-striped">

          <ng-template pTemplate="colgroup">
            <colgroup>
              <col style="width:65px">
              <col style="width:100px">
              <col style="width:120px">
              <col style="width:120px">
              <col style="width:300px">
              <col style="width:70px">
            </colgroup>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th class="text-center">S.No.</th>
              <th>Milestone</th>
              <th>Dated</th>
              <th>
                Status
              </th>
              <th>Reason</th>
              <th class="text-center">Files </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-data let-i="rowIndex">
            <tr>
              <td class="text-center"> {{i+1}}</td>
              <td>
                {{data?.milestonename}}
              </td>
              <td>
                {{data?.dated}}
              </td>
              <td>
                <div class="d-flex flex-column"> <label class="label">{{data?.status1}} </label>

                </div>
              </td>
              <td>{{data?.description}}</td>
              <td class="text-center">

                <i class="pi pi-images pointer me-2" pTooltip="View Files" tooltipPosition="bottom"
                  (click)="openImages(data)"></i>


              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" class="text-center">
                No record found
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </mat-expansion-panel>
  </div>
</div>




<p-sidebar [(visible)]="prerequisitesPopup" position="right" [baseZIndex]="100" appendTo="body"
  styleClass="p-sidebar-md gSidebar" [style]="{width: '65vw'}" [showCloseIcon]=true [dismissible]=false>
  <ng-template pTemplate="header">
    <h5 class="me-auto heading2">{{'Lab Prerequisites'}}</h5>
  </ng-template>
  <div class="row align-items-center tabledesign">
    <p-table [scrollable]="true" [value]="prerequisitesList?._lstPrerequisiteData" styleClass="p-datatable-striped">
      <ng-template pTemplate="caption">
        <h4 class="tableheading mb-0">Lab Type : {{prerequisitesList?._lstPrerequisiteData[0]?.labtype}}</h4>
      </ng-template>
      <ng-template pTemplate="colgroup">
        <colgroup>
          <col style="width:65px">
          <col style="width:120px">
          <col style="width:320px">
          <col style="width:100px">
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th class="text-center">S.No.</th>
          <th>Equipment Name</th>
          <th>Requirments</th>
          <th>Unit Type </th>

        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-i="rowIndex">
        <tr>
          <td class="text-center">{{i+1}} </td>
          <td>
            {{data?.equipmentname}}
          </td>
          <td>{{data?.requirments}} </td>
          <td>
            {{data?.unittype}}
          </td>


        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" class="text-center">
            No record found
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-sidebar>

<p-sidebar [(visible)]="listOfItemsPopup" position="right" [baseZIndex]="100" appendTo="body"
  styleClass="p-sidebar-md gSidebar" [style]="{width: '69vw'}" [showCloseIcon]=true [dismissible]=false>
  <ng-template pTemplate="header">
    <h5 class="me-auto heading2">{{'List of Items'}}</h5>
  </ng-template>
  <div class="row align-items-center tabledesign">
    <p-table [scrollable]="true" [value]="listOfItemsList?._lstItemListData" styleClass="p-datatable-striped">
      <ng-template pTemplate="caption">
        <h4 class="tableheading mb-0">Lab Type : {{listOfItemsList?._lstItemListData[0]?.labtype}}</h4>
      </ng-template>
      <ng-template pTemplate="colgroup">
        <colgroup>
          <col style="width:50px">
          <col style="width:100px">
          <col style="width:400px">
          <col style="width:102px">
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th class="text-center">S.No.</th>
          <th>Equipment Name</th>
          <th>Specification</th>
          <th>Qty. Per School </th>

        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-i="rowIndex">
        <tr>
          <td class="text-center">{{i+1}} </td>
          <td>
            {{data?.itemname}}
          </td>
          <td>{{data?.specification}} </td>
          <td class="text-center">
            {{data?.totqty}}
          </td>


        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" class="text-center">
            No record found
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-sidebar>

<p-sidebar [(visible)]="imgPopup" position="right" [baseZIndex]="100" appendTo="body" styleClass="p-sidebar-md gSidebar"
  [style]="{width: '69vw'}" [showCloseIcon]=true [dismissible]=false>
  <ng-template pTemplate="header">
    <h5 class="me-auto heading2">{{'List of Document'}}</h5>
  </ng-template>

  <div class="card border-0">
    <div class=" ">
      <div class="row" *ngIf="images">
        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12 docs_list mb-3" *ngFor="let image of images; let index = index" key="index">
          <div class="">
            <div *ngIf="image.isPdf" class="pointer d-flex justify-content-center align-items-center data_img"
              (click)="imageClick(index)">
              <span class="material-icons fs-pdf text-danger">picture_as_pdf</span>
            </div>
            <img *ngIf="!image.isPdf" [src]="image.itemImageSrc" class="img-fluid pointer data_img" [alt]="image.alt"
              (click)="imageClick(index)" />
            <h4>
              {{image.title}}
              <p class="caption-p"><span class="material-icons fs-6 pointer ms-2" ptoolTip="Download"
                  tooltipPosition="top" (click)="downloadFile(image.base64, image.title)">download</span></p>
            </h4>
          </div>
        </div>
      </div>
      <!-- <div *ngFor="let image of images; let index = index" class="col-md-3 mb-3" key="index">
        <img [src]="image.itemImageSrc" [alt]="image.alt" style="cursor: pointer;width: 210px;height: 152px"
          (click)="imageClick(index)" />
        <div class="d-flex align-items-center">
          <h4 style="font-size: 10px;">
            {{image.title}}
          </h4>
          <p class="caption-p"><span class="material-icons fs-6 pointer ms-2" ptoolTip="Download" tooltipPosition="top"
              (click)="downloadFile(image.itemImageSrc, image.title)">download</span></p>
        </div>
      </div> -->
    </div>
    <!-- <button mat-raised-button type="button" (click)="printReport()" color="primary"
      class="btn addnew me-2">Report</button> -->

  </div>
</p-sidebar>

<!-- Kept outside the sidebar: the sidebar's transform breaks position:fixed and its z-index hides the full-screen mask -->
<p-galleria [value]="images" [(visible)]="displayCustom" [(activeIndex)]="activeIndex"
  [responsiveOptions]="responsiveOptions" [containerStyle]="{ 'max-width': '850px' }" [numVisible]="7"
  [circular]="true" [fullScreen]="true" [showItemNavigators]="true" [showThumbnails]="false" [baseZIndex]="2000">
  <ng-template pTemplate="item" let-item>
    <img [src]="item.itemImageSrc" class="gallery-img-one" />
  </ng-template>
  <ng-template pTemplate="caption" let-item>
    <div class="d-flex align-items-center">
      <h4 class="caption-h4">
        {{item.title}}
      </h4>
      <p class="caption-p"><span class="material-icons fs-6 pointer ms-2" ptoolTip="Download" tooltipPosition="top"
          (click)="downloadFile(item.base64, item.title)">download</span></p>
    </div>
  </ng-template>
</p-galleria>